/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useFieldArray, useForm, Controller } from "react-hook-form";
import {
  Flex,
  Heading,
  Button,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { DateTimePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import { MdDeleteSweep } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { SERVICE_WINDOW_DEFAULT } from "../constants";
import { dateTimeFormat } from "../../../utils/constants";

export default function ServiceWindow({ addData, serviceWindows }) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const {
    handleSubmit,
    setValue,
    watch,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...SERVICE_WINDOW_DEFAULT,
      serviceWindows: [...serviceWindows],
    },
  });
  const generalFieldProps = { control, errors };
  const { fields: serviceWindowFields, remove: serviceWindowRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "serviceWindows",
    });

  useEffect(() => {
    if (addData) {
      addData([...serviceWindows]);
    }
  }, [watch("serviceWindows")]);

  const submitInfo = (data) => {
    const _windows = [...serviceWindowFields];
    const newWindow = {
      startDateTime: data.startDateTime,
      endDateTime: data.endDateTime,
      cutOffTime: data.cutOffTime,
    };
    if (currentEditing !== null) {
      _windows[currentEditing] = newWindow;
      setCurrentEditing(null);
    } else {
      _windows.push(newWindow);
    }
    reset({
      ...SERVICE_WINDOW_DEFAULT,
      serviceWindows: [..._windows],
    });
  };

  const editWindowCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit Service Window"
          cursor="pointer"
          onClick={() => {
            reset({
              ...SERVICE_WINDOW_DEFAULT,
              ...dataItem,
              serviceWindows: [...serviceWindowFields],
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteWindowCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete Service Window"
          cursor="pointer"
          onClick={() => {
            serviceWindowRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const cancelEditing = () => {
    reset({
      ...SERVICE_WINDOW_DEFAULT,
      serviceWindows: [...serviceWindowFields],
    });
    setCurrentEditing(null);
  };
  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Service Window</Heading>
      </Flex>

      <FormControl isRequired>
        <FormLabel>Start Date Time</FormLabel>
        <Controller
          control={generalFieldProps.control}
          name="startDateTime"
          render={({ field }) => {
            return (
              <DateTimePicker
                className={errors.startDateTime ? "error-field" : ""}
                value={field.value || null}
                onChange={(e) => {
                  field.onChange(e.value);
                  setValue("endDateTime", e.value);
                }}
              />
            );
          }}
        />

        {errors ? (
          errors.startDateTime ? (
            <p className="error-message">
              {errors.startDateTime.message || "Please Select Date!"}
            </p>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </FormControl>
      <FormControl isRequired>
        <FormLabel>End Date Time</FormLabel>
        <Controller
          control={generalFieldProps.control}
          name="endDateTime"
          render={({ field }) => {
            return (
              <DateTimePicker
                className={errors.endDateTime ? "error-field" : ""}
                value={field.value || null}
                min={watch("startDateTime")}
                onChange={(e) => {
                  field.onChange(e.value);
                }}
              />
            );
          }}
        />

        {errors ? (
          errors.endDateTime ? (
            <p className="error-message">
              {errors.endDateTime.message || "Please Select Date!"}
            </p>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </FormControl>

      <FormControl isRequired>
        <FormLabel>Cut Off Time</FormLabel>
        <Controller
          control={generalFieldProps.control}
          name="cutOffTime"
          render={({ field }) => {
            return (
              <TimePicker
                className={errors.cutOffTime ? "error-field" : ""}
                value={field.value || null}
                onChange={(e) => {
                  field.onChange(e.value);
                }}
              />
            );
          }}
        />

        {errors ? (
          errors.cutOffTime ? (
            <p className="error-message">
              {errors.cutOffTime.message || "Please Select Time!"}
            </p>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </FormControl>
      <Grid data={serviceWindowFields}>
        <GridColumn
          title="Start Date Time"
          cell={({ dataItem }) => (
            <td>{moment(dataItem.startDateTime).format(dateTimeFormat)}</td>
          )}
        />
        <GridColumn
          title="End Date Time"
          cell={({ dataItem }) => (
            <td>{moment(dataItem.endDateTime).format(dateTimeFormat)}</td>
          )}
        />
        <GridColumn
          title="Cut Off Time"
          cell={({ dataItem }) => (
            <td>{moment(dataItem.cutOffTime).format(dateTimeFormat)}</td>
          )}
        />
        <GridColumn title="Edit" cell={editWindowCell} width={120} />
        <GridColumn title="Delete" cell={deleteWindowCell} width={120} />
      </Grid>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button onClick={cancelEditing}>Cancel</Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditing !== null
            ? "Update Service Window"
            : "Add Service Window"}
        </Button>
      </div>
    </form>
  );
}
